import CTLBatteryStatus from "application/components/CTLBatteryStatus";
import CTLDateStatus from "application/components/CTLDateStatus";
import DefaultCell from "application/components/DefaultCell";

const Attributes = {
  enableAdvanceSearch: true,
  modes:[]
};

const operationURLS = {
  list: "/userCoordinate/list",
};

const getColumns = () => {
  return [
    {
      Header: "Last Update",
      accessor: "updatedOn",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "date",
      width: 6,
      Cell: ({ value }) => <CTLDateStatus value={value} />,
    },
    {
      Header: "Name",
      accessor: "designation",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Number",
      accessor: "extensionNumber",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Geo Cordinate X",
      accessor: "geoX",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Geo Cordinate Y",
      accessor: "geoY",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Zone",
      accessor: "zone",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Department",
      accessor: "department",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "RSRP SIM 1",
      accessor: "rsRpSim1",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "RSRP SIM 2",
      accessor: "rsRpSim2",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width: 6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Battery Percentage",
      accessor: "batteryPercentage",
      displayInList: true,
      isUserGenerated: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLBatteryStatus value={value} />,
    },
  ];
};

export { getColumns, Attributes, operationURLS };
